import { PropsWithChildren, useState } from 'react';
import styles from './field-panel.module.scss';

export interface FieldPanelProps {
	title: string;
	badge?: string;
	defaults?: {
		isExpanded?: boolean;
	}
}

function useStateWithFallback<T>(value: T | null, defaultValue: T) {
	var effectiveValue = (value === null || value === undefined) ? defaultValue : value;
	return useState(effectiveValue);
}

export const FieldPanel = (props: PropsWithChildren<FieldPanelProps>) => {
	const [isExpanded, setIsExpanded] = useStateWithFallback(props.defaults?.isExpanded, true);

	return (
		<div >
			<div className={styles.header} onClick={() => setIsExpanded(!isExpanded)}>
				<span className="title">{props.title}</span>
				{
					props.badge
						? <span className="badge">{props.badge}</span>
						: null
				}
				<i className={`fa fa-chevron-${ isExpanded ? "up" : "down" }`}></i>
			</div>
			{
				isExpanded
					? <div className={styles.body}>{props.children}</div>
					: null
			}
		</div>
	)
}
